import {CERCA_FERMATA} from './CercaFermataTypes'

export const changeCercaFermata = cercaFermata => {
    return {
        type: CERCA_FERMATA,
        load: cercaFermata
    }
}

export const selectNewCercaFermata = (cercaFermata) => {

    return (dispatch) => {
        
        dispatch(changeCercaFermata(cercaFermata))
    }

}